// Pad a string
export const pad = (n, width = 3, z = 0) =>
  (String(z).repeat(width) + String(n)).slice(String(n).length);
// Capitalize a string
export const capitalize = string =>
  string.charAt(0).toUpperCase() + string.slice(1);
/**
 * Capitalizes first letters of words in string.
 * @param {string} str String to be modified
 * @param {boolean=false} lower Whether all other letters should be lowercased
 * @return {string}
 * @usage
 *   capitalizeAllWords('fix this string'); // -> 'Fix This String'
 */
export const capitalizeAllWords = (str, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match =>
    match.toUpperCase()
  );

/**
 * Truncate a string without cutting words
 * Based on https://stackoverflow.com/a/5454303
 * @param {String} text
 * @param {number} [maxLength]
 * @param {String} [endChar]
 * @return {String}
 */
export const truncate = (text, maxLength = 65, endChar = '…') => {
  if (text.length > maxLength) {
    let displayText = `${text} `.substr(0, maxLength);

    displayText = displayText.substr(
      0,
      Math.min(displayText.length, displayText.lastIndexOf(' '))
    );

    displayText += endChar;

    return displayText;
  }
  return text;
};

export function toSlug(string) {
  let slug = string.toLowerCase().trim();
  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';
  /* eslint-disable no-plusplus */
  for (let i = 0, l = from.length; i < l; i++) {
    slug = slug.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  return (
    slug
      // remove invalid chars
      .replace(/[^a-z0-9 -]/g, '')
      // collapse whitespace and replace by -
      .replace(/\s+/g, '-')
      // collapse dashes
      .replace(/-+/g, '-')
  );
}
